import React, {Component} from 'react';
import {Button, Modal, Table} from 'semantic-ui-react';
import './assignedLocationsConflict.scss';

class AssignedLocationsConflictModal extends Component {
  constructor(props) {
    super(props);
    this.state = {'open': false};
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onOpenModalClick = this.onOpenModalClick.bind(this);
  }

  onCloseModalClick() {
    this.setState({'open': false});
  }

  onOpenModalClick() {
    this.setState({'open': true});
  }

  renderLocations() {
    const {locations} = this.props;

    if (!locations.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
  
    return locations.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.HeaderCell textAlign='center'>
            {element.location}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            {element.pickingZoneName}
          </Table.HeaderCell>
        </Table.Row>
      );
    });
  }

  render() {
    const {zone, submitting, handleSubmit} = this.props;
    return (
      <Modal
        size='mini'
        open={this.state.open}
        onOpen={this.onOpenModalClick}
        onClose={this.onCloseModalClick}
        trigger={<Button primary>Guardar</Button>}
        className='assigned-locations-conflict-modal'
      >
        <Modal.Header>Conflicto</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <p className='conflict-message'>
              La(s) siguiente(s) ubicacion(es) corresponde(n) a otras zonas,
              está seguro que desea cambiarla(s) a la zona{' '}
              <strong>{zone}</strong>?
            </p>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center'>
                    Ubicación
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>
                    Nombre de la zona
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>{this.renderLocations()}</Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>Cancelar</Button>
          <Button primary disabled={submitting} onClick={handleSubmit}>
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default AssignedLocationsConflictModal;
